import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

export const accountService = {
    getAccount,
    updateAccount,
    checkSubscriptionType,
    getDashboardOnboarding,
    getLocations,
    getPulseAiCredits,
    buyAdditionalCredits,
};

/*
    subscriptionStatus:
    0 - stripe subscription not created
    1 - subscription created (awaiting payment)
    2 - subscription active
    3 - subscription cancelled (user cancelled their subscription)
    4 - payment issue (invalid card, insufficient funds, etc.)
*/
function getAccount() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/account`, requestOptions).then(handleResponse);
}

function updateAccount(account) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: JSON.stringify(account),
    };

    return fetch(`${BASE_URL}api/account`, requestOptions)
        .then(handleResponse)
        .catch(() => {});
}

function checkSubscriptionType(sessionId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/stripe/subscription/${sessionId}`, requestOptions).then(handleResponse);
}

function getDashboardOnboarding() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/account/onboarding`, requestOptions).then(handleResponse);
}

function getLocations(query, page, pageSize) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(query),
    };

    return fetch(`${BASE_URL}api/locations?page=${page}&pageSize=${pageSize}`, requestOptions).then(handleResponse);
}

function getPulseAiCredits() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/account/credits`, requestOptions).then(handleResponse);
}

function buyAdditionalCredits(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/stripe/buy-additional-credits`, requestOptions).then(handleResponse);
}
